import React from "react";
import Header from "components/layout/header";
import SupportPage from "components/supportAndHelp/SupportPage";
import { TestIdScope, useTestAttrs } from "utils/testid";

const SupportAndHelpContent = () => {
  const rootAttrs = useTestAttrs("page", "Support and help center page");
  const titleAttrs = useTestAttrs("title", "Support and help center");
  const contentAttrs = useTestAttrs("content", "Support and help content");

  return (
    <div
      className="h-full w-full lg:overflow-hidden overflow-y-auto"
      {...rootAttrs}
    >
      <Header
        headerContent={
          <div
            className="w-full lg:text-[32px] sm:text-3xl text-2xl leading-[44px] text-txtPrimary font-medium -tracking-[0.72px] lg:p-0 p-5"
            {...titleAttrs}
          >
            Support and Help Center
          </div>
        }
      />

      <div className="lg:h-full" {...contentAttrs}>
        <SupportPage />
      </div>
    </div>
  );
};

const SupportAndHelp = () => (
  <TestIdScope scope="support-help">
    <SupportAndHelpContent />
  </TestIdScope>
);

export default SupportAndHelp;
